import Select from "@/common/components/Select";
import useDebounce from "@/common/hooks/useDebounce";
import { Mapper } from "@/common/services/mapper";
import { DashboardHiddenFilterProps } from "@/features/company/types/dashboards/dashboard.type";
import { useEquipments } from "@/features/equipments/hooks/useEquipments";
import { EquipmentsTransformer } from "@/features/equipments/services/equipmentTransformer";

const DashboardFilterEquipmentHiddenFilter = ({
  value,
  onChange,
}: DashboardHiddenFilterProps) => {
  const [search, setSearch] = useDebounce('');

  const {
    data: equipmentOptions,
  } = useEquipments({
    filters: {
      search,
    },
    mapper: Mapper.mapWithTransformer({
      transformer: EquipmentsTransformer.optionsTransformer({
        showIcon: false,
      })
    }),
  });

  return (
    <Select
      label="Selecione o equipamento"
      markAsRequired
      options={equipmentOptions}
      onInputChange={setSearch}
      value={value}
      onChange={onChange}
    />
  );
}

export default DashboardFilterEquipmentHiddenFilter;
